// Ordinary feedback is separate from persistent alarm notifications.
function createTransientMessages(render) {
  const active = new Map()
  let version = 0
  function message(input) {
    const options = typeof input === 'string' ? { message: input } : { ...input }
    const type = options.type || 'info'
    const key = typeof options.message === 'string' ? `${type}:${options.message}` : null
    if (key && active.has(key)) return active.get(key)
    const onClose = options.onClose
    let instance
    instance = render({
      ...options,
      type,
      showClose: true,
      duration: options.duration === undefined ? 3000 : options.duration,
      offset: Math.max(80, Number(options.offset) || 0),
      onClose(closed) {
        if (key && active.get(key) === instance) active.delete(key)
        if (onClose) onClose(closed)
      }
    })
    if (key) active.set(key, instance)
    return instance
  }
  for (const type of ['success', 'warning', 'info', 'error']) {
    message[type] = input => message(typeof input === 'string' ? { message: input, type } : { ...input, type })
  }
  message.closeAll = () => {
    active.clear()
    render.closeAll()
  }
  message.sessionVersion = () => version
  message.isCurrentSession = captured => captured === version
  message.resetSession = () => {
    version++
    message.closeAll()
  }
  return message
}
function createScopedMessages(messages, isAlive) {
  const version = messages.sessionVersion()
  const current = () => isAlive() && messages.isCurrentSession(version)
  const scoped = input => current() ? messages(input) : undefined
  for (const type of ['success', 'warning', 'info', 'error']) {
    scoped[type] = input => current() ? messages[type](input) : undefined
  }
  scoped.closeAll = () => { if (current()) messages.closeAll() }
  scoped.resetSession = () => { if (current()) messages.resetSession() }
  return scoped
}
module.exports = { createTransientMessages, createScopedMessages }
